'use strict';

/**
 * Style options for leaflet layers
 */

var MarkerUtil = require('./MarkerUtil');

var Styles = {
  marker: {
    getIcon: MarkerUtil.getIcon,
    active: {
      iconOptions: {
        className: 'active'
      },
      opacity: 1.0
    },
    default: {
      iconOptions: {
        className: 'default'
      },
      opacity: 1.0
    },
    dim: {
      iconOptions: {
        className: 'dim'
      },
      opacity: 0.5
    }
  }
};

module.exports = Styles;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/gcp/lib/LayerStyles.js